var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// TEAM_CHAT_TEMPLATES
var TEAM_CHAT_TEMPLATES = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TeamChatTemplates($id: ID!) {\n    team(id: $id) {\n      id\n      chat_templates {\n        id\n        title\n      }\n    }\n  }\n"], ["\n  query TeamChatTemplates($id: ID!) {\n    team(id: $id) {\n      id\n      chat_templates {\n        id\n        title\n      }\n    }\n  }\n"])));
export var useTeamChatTemplatesQuery = function (options) {
    return useQuery(TEAM_CHAT_TEMPLATES, options);
};
export default TEAM_CHAT_TEMPLATES;
var templateObject_1;
